<div class="new-connection" *ngIf="componentData.channelType && products" (keydown.Space)="$event.stopPropagation()">
    <div class="new-connection_integrationFee" *ngIf="((user.isShipyard || user.isPlanYard || user.isPriceYard)) && ((connectedAccounts > 0 && isOnBoarding) || !isOnBoarding)">
        <div class="mb-4 font-bold">An additional integration fee may apply</div>
        <div class="new-connection_moduleRow">
            <ng-container *ngFor="let product of products">
                <ng-container *ngIf="product.show">
                    <div class="module">
                        <div class="module-icon">
                            <img class="img-fluid" [src]="product.image" alt="image">
                        </div>
                        <div class="module-detail">
                            <div class="module-detail_price">{{product.name}}</div>
                            <div class="module-detail_fee">${{product.fee}}</div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="new-connection_form" [formGroup]="form">
        <div class="new-connection_step-container input-container">
            <div class="new-connection_step-title">1. Account Nickname</div>
            <div>
                <input formControlName="name" type="text" class="input-container_input input-container_input--thin" 
                [ngClass]="{'error': duplicateNameValue}" (keyup)="validateName()"/>
            </div>
        </div>

        <div class="new-connection_step-container input-container" *ngIf="componentData.channelType === 'amazon'">
            <div class="new-connection_step-title">2. Marketplace</div>
            <div>
                <select formControlName="marketPlace" type="text" class="input-container_input input-container_input--thin" placeholder="test">
                    <option value="" disabled selected hidden>Select</option>
                    <option [value]="market.marketplaceid" *ngFor="let market of amazonMarkets">
                        {{ market.name }}
                    </option>
                </select>
            </div>
        </div>
  
    </div>
    <div class="new-connection_step-container">
        <div class="new-connection_step-title">
            3. Click the button below to connect your {{componentData.channelType}} account
        </div>
        <app-button (click)="connectEbay()" [buttonSize]="'action'" [isDisabled]="!form.valid || duplicateNameValue">Connect</app-button>
    </div>   
</div>